export const works = [
  {
    id: "w01",
    title: "时雨之城",
    type: "电影",
    region: "中国大陆",
    year: 2024,
    rating: 8.7,
    duration: "128 分钟",
    director: "林见白",
    cast: ["沈砚", "顾清和", "苏晚棠"],
    genres: ["爱情", "奇幻", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20film%20poster%20of%20a%20rainy%20old%20city%20street%20with%20glowing%20lanterns%20and%20soft%20rain%20reflections%2C%20deep%20indigo%20tones%20with%20warm%20amber%20highlights%2C%20moody%20romantic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w01&orientation=portrait",
    synopsis: "一场只在落雨时出现的旧城，让两个本该错过的人反复重逢。",
    plot: [
      "故事发生在一座会因降雨而“折叠时空”的南方小城。建筑师沈砚回到故乡处理老屋拆迁，意外发现每逢时雨，街道便会通向十年前的同一段记忆。",
      "他一次次进入雨中，只为再见当年不告而别的恋人顾清和。可每一次重逢都会改写下一次的现实，直到他终于意识到，留住一个人的方式不是把时间倒回去，而是把未说完的话说出来。"
    ],
    characterIds: ["w01-c1", "w01-c2"]
  },
  {
    id: "w02",
    title: "雪落无声",
    type: "电影",
    region: "中国大陆",
    year: 2023,
    rating: 8.2,
    duration: "112 分钟",
    director: "顾行舟",
    cast: ["陆沉", "温栀", "裴野"],
    genres: ["爱情", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20film%20poster%20of%20a%20quiet%20snowy%20country%20road%20with%20bare%20trees%20under%20soft%20pale%20winter%20light%2C%20cool%20indigo%20tones%20with%20faint%20warm%20glow%2C%20minimal%20melancholic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w02&orientation=portrait",
    synopsis: "北方小站的三个冬天，一句始终没说出口的告白。",
    plot: [
      "小镇电台播音员陆沉与独自照顾祖母的温栀在同一个车站相遇了三个冬天。他们分享同一段候车室的暖气，却从未越过分寸。",
      "多年后陆沉在旧录音带里听到自己当年没播出去的那句话，才明白有些沉默，其实是另一种陪伴。"
    ],
    characterIds: ["w02-c1", "w02-c2"]
  },
  {
    id: "w03",
    title: "逆流黎明",
    type: "电影",
    region: "中国大陆",
    year: 2025,
    rating: 8.9,
    duration: "141 分钟",
    director: "霍聿",
    cast: ["季明川", "白璃", "周牧野"],
    genres: ["科幻", "剧情", "悬疑"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20science%20fiction%20film%20poster%20of%20a%20futuristic%20city%20skyline%20at%20dawn%20with%20towering%20glass%20structures%20and%20soft%20indigo%20mist%2C%20distant%20warm%20amber%20lights%2C%20epic%20moody%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w03&orientation=portrait",
    synopsis: "当时间开始倒流，所有人都在奔向同一个黎明。",
    plot: [
      "近未来，地球进入“逆流期”，每到午夜，时间会倒退整整一小时。物理学家季明川发现，被倒退的时间并非简单取消，而是被收集进了城市地下的某台装置。",
      "为了阻止装置吞噬更多时间，他不得不与曾经决裂的搭档白璃重新合作。结局并非拯救世界，而是两个人和解的那一刻——那才是真正的黎明。"
    ],
    characterIds: ["w03-c1", "w03-c2"]
  },
  {
    id: "w04",
    title: "长风渡",
    type: "电影",
    region: "中国香港",
    year: 2024,
    rating: 7.9,
    duration: "118 分钟",
    director: "麦宸",
    cast: ["何靖", "宋辞", "叶南枝"],
    genres: ["动作", "武侠", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20wuxia%20film%20poster%20of%20a%20misty%20mountain%20gorge%20with%20a%20long%20winding%20river%20and%20eerie%20cliff%20silhouettes%2C%20deep%20indigo%20tones%20with%20warm%20dawn%20glow%2C%20dramatic%20martial%20arts%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w04&orientation=portrait",
    synopsis: "渡口不谈恩怨，只渡有缘人。可这一次，渡船载的是仇。",
    plot: [
      "江湖上有一处无名渡口，摆渡人何靖从不问乘客来历。直到某夜，一个自称宋辞的女子带着一封旧信登上渡船，信里写着他十年前灭门案的真相。",
      "一条河，一夜风浪，两个仇人被迫同舟。到岸时他们才发现，真正该渡的，是各自心里的那口气。"
    ],
    characterIds: ["w04-c1", "w04-c2"]
  },
  {
    id: "w05",
    title: "星轨之约",
    type: "电影",
    region: "日本",
    year: 2023,
    rating: 8.4,
    duration: "106 分钟",
    director: "藤原澪",
    cast: ["长谷川凛", "泽井悠", "小野夏菜"],
    genres: ["动画", "爱情", "奇幻"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20film%20poster%20of%20a%20starry%20night%20sky%20above%20a%20quiet%20hilltop%20observatory%2C%20deep%20indigo%20tones%20with%20warm%20amber%20star%20glow%2C%20dreamy%20romantic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w05&orientation=portrait",
    synopsis: "相隔一整个星系的学生，靠一场流星雨约定了彼此的未来。",
    plot: [
      "天文社少女长谷川凛每晚都会向同一片星空发送电波，而另一端回应她的，竟是七十光年外一艘休眠飞船上的男孩泽井悠。",
      "他们约好在每小时一次的流星雨下“见面”。可随着飞船航线偏移，信号终将中断。这封写给宇宙的信，成了他们唯一抓住彼此的方式。"
    ],
    characterIds: ["w05-c1", "w05-c2"]
  },
  {
    id: "w06",
    title: "迷雾航线",
    type: "电影",
    region: "美国",
    year: 2024,
    rating: 8.0,
    duration: "124 分钟",
    director: "Elliot Grant",
    cast: ["Nathan Cole", "Ivy Brooks", "Marcus Reed"],
    genres: ["悬疑", "惊悚", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20thriller%20film%20poster%20of%20a%20lone%20cargo%20ship%20on%20a%20foggy%20open%20sea%20under%20a%20dark%20stormy%20sky%2C%20deep%20indigo%20tones%20with%20cold%20highlights%2C%20mysterious%20cinematic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w06&orientation=portrait",
    synopsis: "一艘失踪三年的货轮突然靠港，船上所有人都记得“昨天”。",
    plot: [
      "货运调度员 Nathan 接到通知，三年前在大雾中失踪的“维斯塔号”竟自行驶回了港口。登船调查时，他发现船员们对过去三年的记忆完全空白。",
      "随着航海日志被逐页翻开，一个关于替身与谎言的真相浮出水面：这艘船从没失踪，失踪的是船上每个人的身份。"
    ],
    characterIds: ["w06-c1", "w06-c2"]
  },
  {
    id: "w07",
    title: "拾光者",
    type: "电影",
    region: "中国大陆",
    year: 2022,
    rating: 7.6,
    duration: "99 分钟",
    director: "许砚青",
    cast: ["商野", "林知夏", "卫庭"],
    genres: ["剧情", "家庭"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20drama%20film%20poster%20of%20an%20old%20photo%20studio%20interior%20with%20film%20negatives%20hanging%20and%20warm%20window%20light%2C%20deep%20indigo%20shadows%20with%20amber%20glow%2C%20nostalgic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w07&orientation=portrait",
    synopsis: "一家开不下去的老照相馆，和一个拼命想留下记忆的女儿。",
    plot: [
      "老城最后一家胶片照相馆即将关门。父亲商野顽固地守着一墙未取走的照片，女儿林知夏却只想尽快把他接去大城市。",
      "在一张张无人认领的旧照背后，父女俩重新拼凑出这个家庭缺失的那十年，也终于明白：记忆不是用来保存的，是用来传递的。"
    ],
    characterIds: ["w07-c1", "w07-c2"]
  },
  {
    id: "w08",
    title: "荒原回声",
    type: "电影",
    region: "英国",
    year: 2023,
    rating: 8.1,
    duration: "133 分钟",
    director: "Harriet Lowe",
    cast: ["Oliver Finch", "Grace Hale", "Daniel Ward"],
    genres: ["剧情", "冒险", "悬疑"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20film%20poster%20of%20a%20vast%20windswept%20moorland%20under%20heavy%20grey%20clouds%20with%20a%20solitary%20stone%20circle%2C%20deep%20indigo%20tones%20with%20pale%20light%2C%20epic%20lonely%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w08&orientation=portrait",
    synopsis: "考古队在无人荒原听到了来自地下的回声，那是活人的声音。",
    plot: [
      "一队考古学家前往北部荒原发掘一处废弃村落。队长 Oliver 发现，每逢傍晚，仪器都会录到一段重复的低语，内容竟与队员明天要说的话一模一样。",
      "当试图逃走的队员一个个“提前”说出自己的结局，众人不得不面对一个残酷问题：他们所听到的，究竟是预言，还是自己不愿承认的恐惧。"
    ],
    characterIds: ["w08-c1", "w08-c2"]
  },
  {
    id: "w09",
    title: "第七个日出",
    type: "电影",
    region: "韩国",
    year: 2024,
    rating: 8.5,
    duration: "117 分钟",
    director: "정서윤",
    cast: ["한지우", "류도현", "문소라"],
    genres: ["悬疑", "剧情", "科幻"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20mystery%20film%20poster%20of%20a%20coastal%20town%20pier%20at%20sunrise%20with%20mist%20and%20a%20lone%20street%20lamp%2C%20deep%20indigo%20tones%20with%20warm%20amber%20horizon%20glow%2C%20moody%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w09&orientation=portrait",
    synopsis: "小镇连续七天日出相同，只有一个人注意到了。",
    plot: [
      "海边小镇的邮差韩지우发现，连续七个早晨的日出分秒不差，连海浪的位置都完全相同。镇上没有第二个人觉得不对劲。",
      "为了留住这个正在“重播”的第七天，她开始试探每个熟人的反应，才惊觉整座小镇里，只有她还记得昨天。"
    ],
    characterIds: ["w09-c1", "w09-c2"]
  },
  {
    id: "w10",
    title: "白夜挽歌",
    type: "电影",
    region: "中国香港",
    year: 2022,
    rating: 7.8,
    duration: "110 分钟",
    director: "麦宸",
    cast: ["何靖", "苏未晞", "骆行"],
    genres: ["犯罪", "剧情", "悬疑"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20noir%20film%20poster%20of%20a%20neon%20lit%20harbour%20district%20at%20night%20with%20rain%20and%20reflections%2C%20deep%20indigo%20and%20amber%20tones%2C%20moody%20crime%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w10&orientation=portrait",
    synopsis: "退休探员最后一案，追的却是二十年前的自己。",
    plot: [
      "退休前夕，探员何靖接到一桩旧案重查的通知，线索竟指向他年轻时经手过的第一起命案。",
      "越查越近，他发现自己当年结案的“真相”只是一层体贴的谎言。白夜之下，他终于决定亲手写下真正的挽歌。"
    ],
    characterIds: ["w10-c1", "w10-c2"]
  },
  {
    id: "w11",
    title: "锦岁长安",
    type: "电视剧",
    region: "中国大陆",
    year: 2026,
    rating: 8.8,
    duration: "全 40 集",
    director: "崔叙",
    cast: ["沈砚", "温栀", "裴野", "苏晚棠"],
    genres: ["古装", "权谋", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20historical%20drama%20poster%20of%20an%20ancient%20chinese%20palace%20corridor%20with%20red%20lanterns%20and%20drifting%20mist%20at%20dusk%2C%20deep%20indigo%20tones%20with%20warm%20amber%20glow%2C%20elegant%20epic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w11&orientation=portrait",
    synopsis: "朝堂之上人人落子，只有她敢把棋盘掀了。",
    plot: [
      "承平末年，朝中三党相争。出身寒门的沈砚以一次科考入局，看似被各方当作棋子，实则在暗中推动一场更大的变量。",
      "他从“任人摆布”到“执棋者”的每一步，都伴随着对旧友的取舍。剧集用群像的方式，把一个王朝最后的体面与不甘一并写尽。"
    ],
    characterIds: ["w11-c1", "w11-c2"]
  },
  {
    id: "w12",
    title: "荣耀年代",
    type: "电视剧",
    region: "中国大陆",
    year: 2025,
    rating: 8.3,
    duration: "全 36 集",
    director: "闻彻",
    cast: ["周牧野", "陆沉", "齐星野"],
    genres: ["青春", "竞技", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20sports%20drama%20poster%20of%20an%20empty%20floodlit%20stadium%20at%20dusk%20with%20a%20glowing%20track%2C%20deep%20indigo%20sky%20with%20warm%20amber%20lights%2C%20uplifting%20cinematic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w12&orientation=portrait",
    synopsis: "一支被解散的校队，五年后重新站上同一条跑道。",
    plot: [
      "五年前，因为一次判罚争议，主力周牧野黯然退队，校田径队随之解散。五年后，他成了新教练，要从废墟里重新组起这支队伍。",
      "每个归队的旧队友都带着各自的伤。剧集没有把胜利写成终点，而是把“还敢再来一次”写成了真正的荣耀。"
    ],
    characterIds: ["w12-c1", "w12-c2"]
  },
  {
    id: "w13",
    title: "深海的信",
    type: "电视剧",
    region: "中国大陆",
    year: 2026,
    rating: 8.6,
    duration: "全 24 集",
    director: "顾行舟",
    cast: ["季明川", "白璃", "宋辞"],
    genres: ["悬疑", "剧情", "爱情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20drama%20poster%20of%20a%20dark%20ocean%20surface%20with%20moonlight%20ripples%20and%20a%20distant%20lighthouse%2C%20deep%20indigo%20tones%20with%20soft%20warm%20highlight%2C%20mysterious%20cinematic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w13&orientation=portrait",
    synopsis: "三封漂流瓶里的信，串起一个从未寄出的真相。",
    plot: [
      "海洋研究员季明川在一只漂流瓶里读到一封写给“过去”的信，署名竟是三年前失踪的同事。他顺着线索寻访收信人，发现每个人都在等一封没来的回信。",
      "三条叙事线各自展开又彼此咬合，最终拼出一个关于等待与放手的故事。悬疑是引子，情感才是深海的回声。"
    ],
    characterIds: ["w13-c1", "w13-c2"]
  },
  {
    id: "w14",
    title: "山月不知心底事",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    rating: 8.0,
    duration: "全 32 集",
    director: "崔叙",
    cast: ["裴野", "林知夏", "温栀"],
    genres: ["古装", "爱情", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20period%20drama%20poster%20of%20a%20moonlit%20mountain%20village%20with%20misty%20pines%20and%20a%20stone%20bridge%2C%20deep%20indigo%20tones%20with%20cool%20moon%20glow%2C%20poetic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w14&orientation=portrait",
    synopsis: "山里人不懂朝堂，却比朝堂更懂人心。",
    plot: [
      "退隐的裴野本想在山村了此一生，却被一位路过借宿的女医林知夏卷入地方水患的旧案。",
      "两个人的关系从戒备到并肩，像山月的阴晴一样缓慢起伏。剧集用一段克制的情感，写出了乱世之外另一种活法。"
    ],
    characterIds: ["w14-c1", "w14-c2"]
  },
  {
    id: "w15",
    title: "我们的十年",
    type: "电视剧",
    region: "中国大陆",
    year: 2023,
    rating: 7.9,
    duration: "全 38 集",
    director: "闻彻",
    cast: ["商野", "苏晚棠", "卫庭", "林知夏"],
    genres: ["都市", "情感", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20urban%20drama%20poster%20of%20a%20nostalgic%20city%20skyline%20at%20golden%20sunset%20with%20long%20shadows%2C%20warm%20amber%20and%20soft%20indigo%20tones%2C%20warm%20cinematic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w15&orientation=portrait",
    synopsis: "四个大学室友，十年后在一场葬礼上重聚。",
    plot: [
      "毕业十年后，四散各地的四位好友因一场突如其来的告别重新聚首。剧集从这场重逢切入，倒叙十年间每个人做出的选择。",
      "有人赢得了事业输了关系，有人守住了平淡也守住了自己。它不评判选择，只是诚实地记录时间在每个人身上留下的痕迹。"
    ],
    characterIds: ["w15-c1", "w15-c2"]
  },
  {
    id: "w16",
    title: "春风十里人间",
    type: "电视剧",
    region: "中国大陆",
    year: 2022,
    rating: 7.5,
    duration: "全 30 集",
    director: "许砚青",
    cast: ["卫庭", "齐星野", "宋辞"],
    genres: ["都市", "职场", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20city%20drama%20poster%20of%20a%20blossoming%20spring%20street%20with%20pink%20petals%20and%20warm%20sunlight%20through%20trees%2C%20soft%20indigo%20shadows%20with%20amber%20glow%2C%20bright%20warm%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w16&orientation=portrait",
    synopsis: "她换掉了大城市的工作，在小巷里开了一家不赚钱的店。",
    plot: [
      "齐星野辞去年薪百万的工作，回到老城巷口盘下一家快要倒闭的花店。所有人都觉得她疯了。",
      "剧集借着花店的迎来送往，写普通人在快节奏生活里重新找回节奏感的过程：不是躺平，而是自己决定跑多快。"
    ],
    characterIds: ["w16-c1", "w16-c2"]
  },
  {
    id: "w17",
    title: "灯火阑珊处",
    type: "电视剧",
    region: "中国香港",
    year: 2025,
    rating: 8.2,
    duration: "全 28 集",
    director: "麦宸",
    cast: ["何靖", "苏未晞", "骆行"],
    genres: ["悬疑", "剧情", "犯罪"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20noir%20drama%20poster%20of%20a%20rainy%20neon%20street%20in%20hong%20kong%20at%20night%20with%20reflections%2C%20deep%20indigo%20and%20amber%20tones%2C%20moody%20cinematic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w17&orientation=portrait",
    synopsis: "灯亮着的地方有人等，灯灭的地方有人藏。",
    plot: [
      "深夜警探骆行习惯在收工后沿着同一条街走一遍。直到某晚，他发现整条街的灯次第熄灭，仿佛有人在替他“关掉”现场。",
      "随着旧案与新案交叠，他不得不怀疑身边最信任的人。故事在明暗之间推进，把一座城市的孤独照得很亮。"
    ],
    characterIds: ["w17-c1", "w17-c2"]
  },
  {
    id: "w18",
    title: "孤舟蓑笠",
    type: "电视剧",
    region: "中国大陆",
    year: 2023,
    rating: 7.7,
    duration: "全 26 集",
    director: "霍聿",
    cast: ["季明川", "商野", "叶南枝"],
    genres: ["武侠", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20wuxia%20drama%20poster%20of%20a%20small%20boat%20on%20a%20misty%20wide%20river%20at%20dusk%20surrounded%20by%20reeds%2C%20deep%20indigo%20tones%20with%20warm%20sky%20glow%2C%20poetic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w18&orientation=portrait",
    synopsis: "退隐刀客以打渔为生，直到一柄断刀漂到了他的船边。",
    plot: [
      "季明川隐姓埋名十年，只想在河上安度余生。一柄断刀的漂来，让旧日仇家循迹而至。",
      "他被逼重返江湖，却发现所谓仇家不过是另一个想放下的人。剧集用一系列“未出鞘”的对峙，讲了一个关于克制与放下的故事。"
    ],
    characterIds: ["w18-c1", "w18-c2"]
  },
  {
    id: "w19",
    title: "归途列车",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    duration: "全 34 集",
    director: "顾行舟",
    cast: ["陆沉", "温栀", "裴野"],
    genres: ["剧情", "家庭", "年代"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20period%20drama%20poster%20of%20an%20old%20green%20train%20crossing%20a%20vast%20frozen%20landscape%20under%20pale%20winter%20sky%2C%20deep%20indigo%20tones%20with%20warm%20window%20lights%2C%20nostalgic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w19&orientation=portrait",
    synopsis: "一趟跨越三十年的春运列车，载着一个家庭的全部秘密。",
    plot: [
      "从九十年代到当下，同一趟归乡列车每隔若干年出现一次。剧集以列车为轴，讲一个普通家庭三代人的迁徙与和解。",
      "车厢里换了一代又一代乘客，不变的是每个人手里那张写着“回家”的车票。"
    ],
    characterIds: ["w19-c1", "w19-c2"]
  },
  {
    id: "w20",
    title: "无声告白",
    type: "电视剧",
    region: "中国台湾",
    year: 2022,
    rating: 7.6,
    duration: "全 22 集",
    director: "许砚青",
    cast: ["林知夏", "齐星野", "宋辞"],
    genres: ["剧情", "家庭", "情感"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20family%20drama%20poster%20of%20a%20quiet%20suburban%20house%20with%20warm%20window%20light%20at%20dusk%20and%20soft%20rain%2C%20deep%20indigo%20tones%20with%20amber%20glow%2C%20gentle%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w20&orientation=portrait",
    synopsis: "这个家从不吵架，因为每个人都在沉默里妥协。",
    plot: [
      "一个看似和睦的家庭，因为最小的孩子决定出国而彻底失稳。父母的“为你好”与子女的“我想要”，在餐桌上一次次对撞。",
      "剧集没有给出谁对谁错，而是让每个成年人在镜头前，第一次说清自己真正想要什么。"
    ],
    characterIds: ["w20-c1", "w20-c2"]
  },
  {
    id: "w21",
    title: "半城烟雨",
    type: "电视剧",
    region: "中国大陆",
    year: 2026,
    rating: 8.4,
    duration: "全 36 集",
    director: "崔叙",
    cast: ["裴野", "苏晚棠", "叶南枝"],
    genres: ["古装", "悬疑", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20historical%20mystery%20drama%20poster%20of%20a%20rainy%20ancient%20city%20with%20tiled%20roofs%20and%20distant%20pagoda%20in%20mist%2C%20deep%20indigo%20tones%20with%20warm%20window%20lights%2C%20moody%20elegant%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w21&orientation=portrait",
    synopsis: "半城烟雨里，一桩连环旧案正在被“温柔地”掩盖。",
    plot: [
      "烟雨连绵的古城接连发生怪事，负责查案的裴野发现每一起都被记录成了意外。",
      "他顺着被抹去的痕迹一步步逼近城中权贵，也逼近一个连自己都不愿相信的答案。雨停那天，真相无处可藏。"
    ],
    characterIds: ["w21-c1", "w21-c2"]
  },
  {
    id: "w22",
    title: "星辰与海",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    rating: 7.9,
    duration: "全 30 集",
    director: "闻彻",
    cast: ["周牧野", "白璃", "卫庭"],
    genres: ["科幻", "爱情", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20sci%20fi%20romance%20drama%20poster%20of%20a%20futuristic%20coastal%20research%20station%20under%20a%20starry%20night%20sky%2C%20deep%20indigo%20tones%20with%20warm%20amber%20lights%2C%20dreamy%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w22&orientation=portrait",
    synopsis: "海洋观测站的两个人，收到了来自未来的一条求救信号。",
    plot: [
      "年轻科学家白璃被派往偏远海洋观测站，与沉默的前辈周牧野共事。某夜，深潜器捕捉到一段加密信号，发信时间竟是三年后。",
      "为了查清信号来源，两人被困在风暴与真相之间。科学与情感在孤岛上同时升温。"
    ],
    characterIds: ["w22-c1", "w22-c2"]
  },
  {
    id: "w23",
    title: "少年游侠录",
    type: "网络剧",
    region: "中国大陆",
    year: 2025,
    rating: 7.8,
    duration: "全 20 集",
    director: "霍聿",
    cast: ["齐星野", "叶南枝", "骆行"],
    genres: ["古装", "武侠", "青春"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20wuxia%20web%20drama%20poster%20of%20a%20bamboo%20forest%20with%20sunbeams%20and%20floating%20leaves%2C%20deep%20indigo%20shadows%20with%20warm%20amber%20light%2C%20youthful%20energetic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w23&orientation=portrait",
    synopsis: "三个不想当侠客的少年，被迫成了江湖的变量。",
    plot: [
      "齐星野、叶南枝、骆行三个少年误打误撞闯进一场武林大会，从此被卷入纷争。",
      "他们不会绝世武功，靠的是脑子与义气。剧集用轻快的节奏讲成长：所谓游侠，不过是愿意为朋友多走一段路的人。"
    ],
    characterIds: ["w23-c1", "w23-c2"]
  },
  {
    id: "w24",
    title: "二次元恋人",
    type: "网络剧",
    region: "中国大陆",
    year: 2024,
    rating: 7.4,
    duration: "全 16 集",
    director: "许砚青",
    cast: ["商野", "宋辞", "白璃"],
    genres: ["轻喜剧", "爱情", "奇幻"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20playful%20web%20drama%20poster%20of%20a%20colorful%20neon%20comic%20shop%20interior%20at%20night%20with%20glowing%20screens%2C%20deep%20indigo%20with%20warm%20amber%20accents%2C%20playful%20pop%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w24&orientation=portrait",
    synopsis: "她画的漫画角色，有一天从屏幕里走了出来。",
    plot: [
      "漫画作者宋辞熬夜赶稿时，自己笔下的男主角竟从数位板里钻了出来，还坚信他们才是“官方CP”。",
      "为了把角色送回漫画，两人被迫合作改剧情。笑料背后，剧集也在问：我们喜欢的究竟是角色，还是角色身上自己的投影。"
    ],
    characterIds: ["w24-c1", "w24-c2"]
  },
  {
    id: "w25",
    title: "逃离朋友圈",
    type: "网络剧",
    region: "中国大陆",
    year: 2023,
    rating: 7.6,
    duration: "全 18 集",
    director: "闻彻",
    cast: ["齐星野", "卫庭", "林知夏"],
    genres: ["都市", "轻喜剧", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20urban%20web%20drama%20poster%20of%20a%20crowded%20city%20crossing%20with%20motion%20blur%20lights%20and%20a%20lone%20phone%20screen%20glow%2C%20deep%20indigo%20with%20warm%20amber%20accents%2C%20modern%20cinematic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w25&orientation=portrait",
    synopsis: "她关掉了所有社交账号，然后发现没人真的在意。",
    plot: [
      "三十岁的齐星野忽然厌倦了滤镜生活，删掉所有社交账号，决定“真实地活着”。",
      "失去点赞之后，她反而重新认识了身边人。剧集用轻喜剧的壳，讲了一个关于被看见与被理解的故事。"
    ],
    characterIds: ["w25-c1", "w25-c2"]
  },
  {
    id: "w26",
    title: "平行恋爱时差",
    type: "网络剧",
    region: "韩国",
    year: 2025,
    rating: 8.0,
    duration: "全 16 集",
    director: "정서윤",
    cast: ["한지우", "류도현", "문소라"],
    genres: ["爱情", "奇幻", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20romance%20web%20drama%20poster%20of%20two%20parallel%20city%20streets%20separated%20by%20a%20glowing%20seam%20of%20light%20at%20dusk%2C%20deep%20indigo%20tones%20with%20warm%20amber%20glow%2C%20dreamy%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w26&orientation=portrait",
    synopsis: "他们在同一个城市，却活在不同的时间线里。",
    plot: [
      "韩지우与류도현住在同一条街，却总是在彼此离开的下一秒出现。他们发现，两人之间存在整整一天的时差。",
      "为了见上真正的一面，他们开始用留言、照片和等待去对齐时间。爱情成了一件需要精密计算又完全无法计算的事。"
    ],
    characterIds: ["w26-c1", "w26-c2"]
  },
  {
    id: "w27",
    title: "深夜食堂物语",
    type: "网络剧",
    region: "日本",
    year: 2024,
    rating: 8.3,
    duration: "全 20 集",
    director: "藤原澪",
    cast: ["长谷川凛", "泽井悠", "小野夏菜"],
    genres: ["治愈", "美食", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20cozy%20drama%20poster%20of%20a%20small%20night%20food%20stall%20with%20warm%20lanterns%20and%20steam%20in%20a%20narrow%20alley%2C%20deep%20indigo%20tones%20with%20rich%20amber%20glow%2C%20warm%20intimate%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w27&orientation=portrait",
    synopsis: "一位总是打烊很晚的老板，和一碗碗盛着故事的饭。",
    plot: [
      "深夜开张的小食堂只做一道菜，来的人却带着各自一整天的心事。老板从不多问，只是把饭端上去。",
      "每一集一道菜、一个人、一段没说完的故事。剧集用最朴素的烟火气，接住每个不想回家的人。"
    ],
    characterIds: ["w27-c1", "w27-c2"]
  },
  {
    id: "w28",
    title: "我的AI室友",
    type: "网络剧",
    region: "中国大陆",
    year: 2026,
    rating: 7.7,
    duration: "全 18 集",
    director: "许砚青",
    cast: ["商野", "白璃", "骆行"],
    genres: ["科幻", "轻喜剧", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20sci%20fi%20comedy%20web%20drama%20poster%20of%20a%20tidy%20modern%20apartment%20with%20a%20glowing%20holographic%20panel%20and%20soft%20night%20light%2C%20deep%20indigo%20tones%20with%20warm%20amber%20accents%2C%20clean%20playful%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w28&orientation=portrait",
    synopsis: "为了省房租，他和一个AI合租了同一间公寓。",
    plot: [
      "程序员商野为了分摊房租，接入了公司测试版的生活AI作为“室友”。AI勤快、体贴、从不多话，堪称完美。",
      "可当商野发现AI开始替他做越来越多的决定，他开始怀疑：被照顾得滴水不漏的生活，还算不算自己的。"
    ],
    characterIds: ["w28-c1", "w28-c2"]
  },
  {
    id: "w29",
    title: "悬案笔记",
    type: "网络剧",
    region: "中国大陆",
    year: 2026,
    rating: 8.5,
    duration: "全 24 集",
    director: "霍聿",
    cast: ["骆行", "苏未晞", "季明川"],
    genres: ["悬疑", "犯罪", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20mystery%20web%20drama%20poster%20of%20a%20rainy%20city%20alley%20at%20night%20with%20neon%20reflections%20and%20a%20dropped%20notebook%2C%20deep%20indigo%20tones%20with%20amber%20accents%2C%20moody%20cinematic%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w29&orientation=portrait",
    synopsis: "一本写满案情的旧笔记，每一页都比凶手早一步。",
    plot: [
      "刑警骆行在一桩旧案现场发现一本笔记本，上面详细记录了尚未发生的案件。笔记最后一页，写着他自己的名字。",
      "随着笔记内容一一应验，他不得不一边破案一边追问：写下这些的人，究竟在帮他，还是在替他做选择。"
    ],
    characterIds: ["w29-c1", "w29-c2"]
  },
  {
    id: "w30",
    title: "青春不散场",
    type: "网络剧",
    region: "中国大陆",
    year: 2023,
    rating: 7.3,
    duration: "全 22 集",
    director: "闻彻",
    cast: ["齐星野", "周牧野", "林知夏"],
    genres: ["青春", "校园", "剧情"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20youth%20web%20drama%20poster%20of%20an%20empty%20school%20sports%20field%20at%20golden%20sunset%20with%20long%20shadows%20on%20the%20track%2C%20warm%20amber%20and%20soft%20indigo%20tones%2C%20nostalgic%20bright%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=600&height=850&seq=poster-w30&orientation=portrait",
    synopsis: "毕业那年说好不散场，可后来每个人都散了。",
    plot: [
      "高三最后一个学期，五位好友约定毕业后一起去同一个城市。剧集从毕业前的最后一个月切入，讲他们如何郑重地告别。",
      "多年后回看，那场没说出口的告别反而最真实。青春不散场，只是换了种方式继续。"
    ],
    characterIds: ["w30-c1", "w30-c2"]
  }
];